import { __awaiter, __generator } from "tslib";
export function initializeOBFeedback(appId, env, scriptUrl, styleUrl, intlUrl, userVoiceUrl, userEmail, sessionId, cid, build, primaryColour, secondaryColour, intlFilename, locale, onError, applicationGroup, telemetryGroup, webGroup, userEmailConsentDefault, onDismiss, bugForm, screenshot, eventSampling, showEmailAddress, transitionEnabled, isShowThanks) {
    return __awaiter(this, void 0, void 0, function () {
        var environment, scriptTagId, existingScript, script;
        return __generator(this, function (_a) {
            environment = env === 'Prod' ? 0 : 1;
            window.OfficeBrowserFeedback = window.OfficeBrowserFeedback || {};
            window.OfficeBrowserFeedback.initOptions = {
                appId: appId,
                stylesUrl: styleUrl,
                intlUrl: intlUrl,
                environment: environment,
                userVoice: userVoiceUrl ? { url: userVoiceUrl } : undefined,
                userEmail: userEmail,
                sessionId: sessionId,
                cid: cid,
                build: build,
                primaryColour: primaryColour,
                secondaryColour: secondaryColour,
                intlFilename: intlFilename,
                locale: locale,
                onError: onError,
                applicationGroup: applicationGroup,
                telemetryGroup: telemetryGroup,
                webGroup: webGroup,
                userEmailConsentDefault: userEmailConsentDefault,
                onDismiss: onDismiss,
                bugForm: bugForm,
                screenshot: screenshot,
                eventSampling: eventSampling,
                showEmailAddress: showEmailAddress,
                transitionEnabled: transitionEnabled,
                isShowThanks: isShowThanks
            };
            scriptTagId = 'officebrowserfeedback-jssdk';
            existingScript = document.getElementById(scriptTagId);
            if (!existingScript) {
                script = document.createElement('script');
                script.id = scriptTagId;
                script.src = scriptUrl;
                document.body.appendChild(script);
            }
            return [2];
        });
    });
}
//# sourceMappingURL=OfficeBrowserFeedbackWrapper.js.map